import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from '../../../api/axiosInstance';

export const getSingleOrderFunc = createAsyncThunk(
  "getSingleOrder",
  async (id, thunkAPI) => {
    try {
      const response = await api.get(`dashboard/orders/${id}`);
      return response.data.data.order;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

const getSingleOrderSlicer = createSlice({
  name: "getSingleOrder",
  initialState: {
    loading: false,
    data: null,
    error: null,
    apiErrors: {},
    successMessage: "",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSingleOrderFunc.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.apiErrors = {};
      })
      .addCase(getSingleOrderFunc.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.successMessage = action.payload?.message || "";
      })
      .addCase(getSingleOrderFunc.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.apiErrors = action.payload?.errors || {};
      });
  },
});

export default getSingleOrderSlicer.reducer;